
<script>
import { localstorage } from "../../mixins/localstorage";
import $ from "jquery";
import { onMounted, ref, computed, watch, reactive, nextTick, toRaw } from "vue";
import Recaptcha from "../../common/components/Recaptcha.vue";
import Modal from "../../common/components/Modal.vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';

export default {
  mixins: [localstorage],

  components: {
    Recaptcha,
    Modal,
  },

  props: {
    type: {
      type: String,
      default: "",
    },
    optin: {
      type: String,
      default: "",
    },
    requestFields: {
      type: String,
      default: "",
    },
    subjectFields: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const newForm = reactive({
        type: '',
        subject: '',
        request: '',
        client: '',
        clientnumber: '',
        title: '',
        lastname: '',
        nomcommercial: '',
        firstname: '',
        zipcode: '',
        country: '',
        phone: '',
        email: '',
        messagelong: '',
        mention: '',
        captcha: '',
        acceptance: '',

    });
    const { values, errors, defineField, validate } = useForm({

      validationSchema: yup.object().shape({
        request: yup.string().required('ce champ est requis'),
        isClient: yup.boolean(),
        subjectForm: yup.string().required('ce champ est requis'),
        typeForm: yup.string().required('ce champ est requis'),
        clientnumber: yup.string(),
        lastname: yup.string().required('Le nom est requis'),
        firstname: yup.string().required('Le prénom est requis'),
        categorie: yup.string(),
        email: yup.string().email('L\'email est invalide').required('L\'email est requis'),
        phone: yup
          .string()
          .nullable()
          .notRequired()
          .transform((value) => (value === '' ? null : value))
          .matches(/^(0|\+33)[0-9]{9}$/, 'Le numéro de téléphone est invalide'),
        number: yup.number().required('Le code postal est requis').typeError('Un numéro valide est requis'),
        country: yup.string().required('La ville est requis'),
          }).test('isClient-required', 'isClient est requis', function (values) {
              // Vérifier si isClient doit être obligatoire
              if (showIsClient.value && values.isClient === undefined) {
                return this.createError({ path: 'isClient', message: 'Ce champ est requis' });
              }
              return true;
            }).test('numeroclient-required', 'numeroclient est requis', function(values){
              if((clientnumber.value === "" || clientnumber.value === undefined) && isClient.value && !(typeForm.value === 'Particulier' && subjectForm.value === 'Bouteilles de gaz')){
                  return this.createError({ path: 'clientnumber', message: 'Ce champ est requis' });
                }
                return true;
            })

    })

    const [request, requestAttrs] = defineField('request', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [typeForm, typeFormAttrs] = defineField('typeForm', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [nomcommercial, nomcommercialAttrs] = defineField('nomcommercial', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [clientnumber, clientnumberAttrs] = defineField('clientnumber', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [lastname, lastnameAttrs] = defineField('lastname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [firstname, firstnameAttrs] = defineField('firstname', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });


    const [subjectForm, subjectFormAttrs] = defineField('subjectForm', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [email, emailAttrs] = defineField('email', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });
    const [phone, phoneAttrs] = defineField('phone', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });

    const [country, countryAttrs] = defineField('country', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });

    const [number, numberAttrs] = defineField('number', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });

    const [isClient, isClientAttrs] = defineField('isClient', {
      validateOnMount: false,
      validateOnChange: true,
      validateOnBlur: true,
    });

    const { checkLS } = localstorage.methods;
    const context = ref("");
    const contactFields = ref(null);
    const isDemandeDevis = ref(false);
    const isPosted = ref(false);
    const captchaError = ref(false);
    const displayPopin = ref(false);
    const recaptcha = ref(null);
    const selects = reactive({
      types: ["Particulier", "Professionnel", "Collectivité", "Prescripteur"],
      subjects: [
        { label: "Gaz en citerne" },
        { label: "Bouteilles de gaz" },
        { label: "GPL Carburant" },
        {
          label: "Décret tertiaire",
          haystack: ["Professionnel", "Collectivité"],
        },
        { label: "Prime Energie Maîtrisée" },
        {
          label: "Recherche partenaire chauffage",
          haystack: ["Particulier", "Professionnel", "Collectivité"],
        },
        { label: "Propane en réseau" },
        { label: "Presse" },
        { label: "Sponsoring" },
      ],
      requests: [
        {
          label: "Passer une commande de gaz",
          haystack: ["Gaz en citerne"],
          isLink: true,
          url: "https://monespaceclient.antargaz.fr/portal/#/login",
        },
        {
          label: "Demande de devis",
          haystack: ["Gaz en citerne", "Bouteille de gaz"],
          isLink: true,
          url: "",
        },
        // {
        //   label: "Demande de devis",
        //   haystack: ["Gaz en citerne"],
        //   isLink: true,
        //   url: "https://www.antargaz.fr/citerne-de-gaz/generique-particuliers",
        // },
        // {
        //   label: "Demande de devis",
        //   haystack: ["Gaz en citerne"],
        //   isLink: true,
        //   url: "https://www.antargaz.fr/citerne-de-gaz/generique-professionnels",
        // },
        // {
        //   label: "Demande de devis",
        //   haystack: ["Bouteille de gaz"],
        //   isLink: true,
        //   url: "https://www.antargaz.fr/devenez-client-pro-bouteilles",
        // },
        // {
        //   label: "Demande de devis",
        //   haystack: ["Gaz en citerne"],
        //   isLink: true,
        //   url: "https://www.antargaz.fr/citerne-de-gaz/generique-professionnels",
        // },
        // {
        //   label: "Demande de devis",
        //   haystack: ["Bouteille de gaz"],
        //   isLink: true,
        //   url: "https://www.antargaz.fr/devenez-client-pro-bouteilles",
        // },
        // {
        //   label: "Demande de devis",
        //   haystack: ["Gaz en citerne"],
        //   isLink: true,
        //   url: "https://www.antargaz.fr/citerne-de-gaz/generique-particuliers",
        // },
        { label: "Poser une question" },
        {
          label: "Faire une réclamation",
          haystack: ["Gaz en citerne", "Bouteilles de gaz"],
        },
        {
          label: "Résilier mon contrat",
          haystack: ["Gaz en citerne"],
        },
        {
          label: "Informations contrat/facture",
          haystack: ["Gaz en citerne"],
        },
        // { label: "Demander un devis",
        // }
      ],
      category: [{ label: "Revendeur" }, { label: "Utilisateur" }],
    });

    const formEl = ref(null);

    const phoneNumbers = reactive([
      {
        title: "Numéro pour les demandes commerciales",
        description:
          "Vous êtes à la recherche d’une offre gaz propane en citerne ? Vous souhaitez souscrire une formule SereniPack+, FlexiPack+ ou SereniPro et vous avez des questions ? Nos équipes sont là pour répondre à toutes vos interrogations sur l’ensemble des forfaits gaz et sur toutes les bouteilles de gaz proposées par Antargaz. Ce numéro s’adresse aussi à vous si vous êtes un particulier et que vous souhaitez installer une cuve de gaz enterrée dans votre jardin, ou si vous êtes un professionnel à la recherche d’une solution de gaz en bouteilles. N’hésitez pas à contacter nos experts par téléphone sur ce numéro dédié aux demandes commerciales.",
        phoneNumber: "0 805 509 509",
        isGreen: true,
        hasLink: false,
        subject: "Commercial",
      },
      {
        title: "Vous êtes client ANTARGAZ avec citerne",
        description:
          "Vous voulez savoir à quelle date précise va être livrée votre citerne ou encore qui est chargé d’en assurer la maintenance ? Ou bien vous souhaitez déplacer votre citerne pour faire des travaux, la peindre ou la camoufler et vous vous demandez si ces opérations sont réalisables et comment procéder ? Pour toutes ces questions, une ligne dédiée a été mise en place. Nos conseillers Antargaz sont également disponibles pour répondre à toutes les questions qui concernent votre contrat, vos factures, etc. Un déménagement, un changement de nom ? Nos conseillers vous répondent par téléphone si vous avez le moindre doute.",
        phoneNumber: "0 974 75 75 75",
        isGreen: false,
        hasLink: true,
      },
      {
        title: "Vous êtes client professionnel ANTARGAZ avec bouteilles",
        description:
          "Vous êtes un revendeur ou un utilisateur  professionnel de bouteilles de gaz propane ou butane Antargaz ? Vous souhaitez passer une commande ou vous procurer des accessoires ? Vous avez une interrogation sur l'usage ou le stockage des bouteilles de gaz ? Pour toutes ces questions, une ligne dédiée a été mise en place. Nos conseillers Antargaz sont également disponibles pour répondre à toutes les questions qui concernent votre contrat, vos factures, etc. Un déménagement, une vente, un changement de gérant ? Nos conseillers vous accompagnent si vous avez la moindre question.",
        phoneNumber: "0 980 98 50 50",
        isGreen: false,
        hasLink: false,
        subject: "Bouteilles",
      },
      {
        title: "Vous êtes client ANTARGAZ avec compteur",
        description:
          "Vous êtes client Antargaz avec compteur et vous vous demandez comment réagir parce que votre index de compteur est bloqué ? Vous vous interrogez sur votre facture parce que vous déménagez ou que votre situation personnelle a changé (mariage, divorce, etc.) ? Pour toutes les questions relatives à un contrat en cours avec un compteur, n’hésitez pas à contacter Antargaz. Nos experts sont là pour répondre à toutes vos questions par téléphone.",
        phoneNumber: "0 974 751 751",
        isGreen: false,
        hasLink: false,
        subject: "Compteur",
      },
      {
        title: "Un projet de raccordement au gaz en réseau ?",
        description:
          "Vous êtes gérant d’une société ou propriétaire d’une maison et vous souhaitez que votre installation soit raccordée au réseau de gaz de la commune ? Entreprises et maisons individuelles peuvent bénéficier du raccordement au réseau de gaz propane de la commune ou au réseau de gaz naturel Antargaz si ces derniers sont à proximité. Si vous avez des questions, nos conseillers Antargaz sont disponibles par téléphone sur une ligne dédiée au raccordement au gaz en réseau.",
        phoneNumber: "0 805 800 022",
        isGreen: true,
        hasLink: false,
        subject: "Gaz en réseau",
      },
      {
        title: "Urgence sécurité gaz en citerne",
        description:
          "Vous avez une inquiétude en raison d’un sifflement ou d’une odeur suspecte à proximité de votre citerne de gaz ? Un incendie s’est déclaré dans le voisinage et vous pensez que votre citerne a pu être touchée ? Nos experts sont là pour répondre à toutes vos questions et vous conseiller par téléphone grâce à un numéro d’urgence sécurité dédiée aux installations de gaz en citerne. Si vous avez le moindre doute, contactez un conseiller Antargaz par téléphone.",
        phoneNumber: "0 800 08 24 24",
        isGreen: true,
        hasLink: false,
        subject: "Urgence citerne",
      },
      {
        title: "Urgence sécurité gaz en réseau",
        description:
          "Vous pensez avoir décelé une odeur de gaz dans le voisinage sachant qu’une citerne Antargaz alimente les logements et les commerces du quartier ? Vous suspectez une canalisation défectueuse sur le réseau de gaz naturel de votre quartier ? Nos conseillers sont disponibles par téléphone pour vous assister et vous conseiller en cas d’inquiétude sur le réseau de gaz. Antargaz s’engage à envoyer un technicien en moins d’une heure* pour intervenir (* en cas d’urgence sécurité) sur une installation de gaz en réseau.",
        phoneNumber: "0 801 01 07 07",
        isGreen: true,
        hasLink: false,
        subject: "Urgence gaz en réseau",
      },
    ]);

    const visibleSubjects = computed(() => {
      return selects.subjects.filter(subject => subject.display);
  });

  const visibleRequests = computed(() => {
      return selects.requests.filter(request => request.display);
  });

    const isFormActive = computed(() => {
      return context.value !== "";
    });

    const showForm = computed(() => {
      return !isPosted.value && context.value === "write";
    });

    const showConfirmation = computed(() => {
      return isPosted.value && context.value === "write";
    });

    const showPhones = computed(() => {
      return context.value === "call";
    });

    const showCategory = computed(() => {
      if (["Professionnel", "Collectivité"].includes(typeForm)) {
        return subjectForm.value === "Bouteilles de gaz";
      }
      return false;
    });

    const isParticulier = computed(() => {
      return typeForm === "Particulier";
    });

    const showIsClient = computed(() => {
      const filters = [
        { subject: "Gaz en citerne" },
        {
          subject: "Bouteilles de gaz",
          types: ["Professionnel", "Collectivité", "Particulier"],
        },
        { subject: "Propane en réseau" },
        { subject: "Gaz naturel" },
      ];
      return filters.some((filter) => {
        const isSubject = filter.subject === subjectForm.value;
        const isType = !filter.types || filter.types.includes(typeForm.value);
        return isType && isSubject;
      });
    });

    watch(
      () => toRaw(newForm),
      (newForm) => {
        if (checkLS()) {
          localStorage.setItem("formContent", JSON.stringify(newForm));
        }
      },
      { deep: true }
    );

    watch(subjectForm, async (newSubjectForm, oldSubjectForm) => {
      if (request.value !== "" && request.value !== null && request.value !== undefined) {
        request.value = ""
      }
      if (isClient.value !== "" && isClient.value !== null && isClient.value !== undefined) {
        isClient.value = undefined
      }

      updateSelects();
      resetClientCheckbox();
    });



    watch(isClient, async (newClient, oldClient) => {
      if (request.value !== "" && request.value !== null && request.value !== undefined) {
        request.value = ""
      }
      updateSelects();
    });

    watch(typeForm, async (newType, oldType) => {
      if (request.value !== "" && request.value !== null && request.value !== undefined) {
        request.value = ""
      }
      if (subjectForm.value !== "" && subjectForm.value !== null && subjectForm.value !== undefined) {
        subjectForm.value = ""
      }
      if (isClient.value !== "" && isClient.value !== null && isClient.value !== undefined) {
        isClient.value = undefined
      }
      updateSelects();
      updateSelectsSubject();
    });

    onMounted(async () => {
      await nextTick()
      formEl.value =  document.getElementsByClassName("webform-submission-form")[0];
      isPosted.value = formEl.value.querySelector(".webform-confirmation") !== null;
      if(isPosted.value){
        context.value = localStorage.getItem('type')
        console.log("Is posted so use localstorage value == ", localStorage.getItem('type'))
      }
      else{
        getType()
      }

        let requestFields = props.requestFields
          ? JSON.parse(props.requestFields)
          : [];
        let subjectFields = props.subjectFields
          ? JSON.parse(props.subjectFields)
          : [];
        const rawNewForm = toRaw(newForm);
        Object.assign(rawNewForm, requestFields);
        Object.assign(rawNewForm, subjectFields);

        if (isPosted.value) {
          clearStorage();
        } else if (checkLS()) {
          let sF = JSON.parse(localStorage.getItem("formContent"));
          if (sF !== null) {
            const rawNewForm = toRaw(newForm);
            Object.assign(rawNewForm, sF);
            isClient.value = false;
          }
        }
      contactFields.value =
      document.getElementsByClassName(".form__field:not(.form__field--select)")[0];
      initFAQ();
    });
    /**
     * @param {string} phoneNumber
     */
    function formatPhoneNumber(phoneNumber) {
      return `tel:+33${phoneNumber.substring(1).replaceAll(/\s/g, "")}`;
    }

    function updateDatalayer(formSubject, formRequest) {
      const formData = {
        event: "form_confirmation",
        form_type: "Contact",
        form_name: "Contactez-nous",
        form_mode: context.value == "write" ? "Par_mail" : "Par_telephone",
        //ne remonte plus actuellement
        form_object: formRequest,
        event_detail: formSubject,
        page_chapter1: formSubject,
        page_chapter2: formRequest,
        submission_date: new Date().toISOString().split("T")[0],
      };
      // If we are on the mail side add form_category and new_client to the formData
      if (context.value == "write") {
        formData.form_category = typeForm;
        formData.new_client =
        isClient !== "undefined" ? isClient : false;
      }
      window.dataLayer.push(formData);
    }
    function togglePopin(state) {
      displayPopin.value = state;
    }
    function onCaptchaExpired() {
      recaptcha.value.reset();
      captchaError.value = true;
    }
    const requestChanged = (value) => {
      const req = selects.requests.find(r => r.label === value);
      updateRequests()
      if (req) {
        request.value = value;
        if (req.isLink && req.url) {
          window.open(req.url, "_blank");
          request.value = null
        }
      }
    };

    const updateRequests = () => {
      selects.requests = selects.requests.map((request) => ({
        ...request,
        display: displayField(request.haystack, request.label),
      }));
    };
    function  getType() {
          let requestType = "write";
          console.log('type check before if', new URL(window.location.href).searchParams.get("type") );

          if (new URL(window.location.href).searchParams.get("type") == "call") {
            requestType = "call"
            console.log('if ####################');
            console.log('type check url', new URL(window.location.href).searchParams.get("type") );
            console.log('is type call ?' ,new URL(window.location.href).searchParams.get("type") == "call");
          }
          else{
            const url = new URL(window.location.href);
            console.log(requestType)
            url.searchParams.set('type',  requestType);
            window.history.replaceState({}, '', url);
          }
          context.value = requestType
    }



    function onCaptchaVerified(token) {
      recaptcha.value.reset();
      newForm.captcha = token;
      submitForm();
    }
    function checkRecaptcha() {
      captchaError.value = false;
      recaptcha.value.execute();
    }
    function resetClientCheckbox() {
      newForm.client = false;
      isClient = false;
      setTimeout(() => (document.querySelector("#client").checked = false), 50);
    }

    const submitForm = () => {
        validate()
        .then((result) => {
          if (result.valid && newForm.captcha.length > 0) {
            sendForm()
          }
          else{
            console.log("Validation failed", result.errors);
          }
        })
        .catch((e) => {
          console.log(e)
        })

    };
    function sendForm() {

      newForm.request = request
      newForm.type = typeForm
      newForm.lastname = lastname
      newForm.firstname = firstname
      if(nomcommercial.value !== undefined && nomcommercial.value !== null && nomcommercial.value !== ""){
        newForm.nomcommercial = nomcommercial
      }

      if (clientnumber.value !== undefined && clientnumber.value !== null && clientnumber.value !== "") {
          newForm.clientnumber = clientnumber.value;
      }
      if(isClient.value !== undefined && isClient.value !== null && isClient.value !== ""){
        newForm.client = isClient
      }
      newForm.subject = subjectForm
      newForm.email = email
      newForm.phone = phone
      newForm.country = country
      newForm.zipcode = number

      for (let [key, value] of Object.entries(newForm)) {
        let input = null
        if(key === "subject"){
          input = formEl.value.querySelector('#edit-subject-select')
        }
        else{
          input = formEl.value.querySelector(`[name='${key.toLowerCase()}']`);
        }
        if (input) {
          switch (key) {
            case "mention":
              input.value = value ? props.optin : "";
              break;
            case "acceptance":
              input.value = "Envoyer mon email";
              break;
            default:
              input.value = value;

              break;
          }
        }
      }

      // Set action for tracking
      let action = `${formEl.value.getAttribute('action')}?${newForm.type}&${newForm.subject
        }&${newForm.request}&${newForm.client ? 'client' : 'prospect'}`
      formEl.value.setAttribute('action', action)

      // Datalayer
      updateDatalayer(subjectForm, request);
      localStorage.setItem('type', context.value);
      formEl.value.submit();
    }
    function setContext(ctx) {
      context.value = ctx;
    }
    function navigateToContactPage(ctx) {
      context.value = ctx;
      const url = new URL(window.location.href);
      url.searchParams.set('type', ctx);
      window.history.replaceState({}, '', url);
    }

    function initFAQ() {
      let url = `https://${window.location.host}/questions-reponses`;
      window.addEventListener("STContactFormInputLoaded", function (e) {
        e.detail.init({
          kbId: 182,
          locale: "fr",
          cookieOptin: true,
          filters: {
            thematics: [],
            tags: [],
          },
          labels: {
            title: {
              fr: "Suggestions",
            },
            openOnFaq: {
              fr: "Ouvrir la faq",
            },
            goToFaqLink: {
              fr: "Aller à la faq",
            },
          },

          limit: 5,
          faqUrl: url,
          openInNewTab: true,
          inputId: "messagelong",
          containerId: "st-contact-form-input-container",
        });
      });
      $.getScript(
        "https://assets.app.smart-tribune.com/smart-tribune/ContactFormInput/contactforminput.main.js",
        () => {
          setTimeout(() => {
            new STDFAQ({
              element: "#messagelong",
              customWrapperId: "stdfaq-form",
              platformId: 969,
              pathToFaq: url,
              limit: 3,
            });
          }, 2000);
        }
      );
    }
    function getSelectEmailValue() {
      if (subjectForm === "Prime économie d’énergie")
        return "economie_energie";

      if (!isClient && request === "Souscrire à une offre")
        return "pas_encore_client";

      return "";
    }
    function setFocusState(event) {
      event.target.parentNode.classList.add("form__field--active");
    }
    function setBlurState(event) {
      if (event.target.value === "")
        event.target.parentNode.classList.remove("form__field--active");
    }
    function clearStorage() {
      if (checkLS()) {
        localStorage.removeItem("formContent");
        localStorage.removeItem("type");
      }
    }
    function updateSelects() {
      selects.requests.forEach((request) => {
      request.display = displayField(request.haystack, request.label);
    });
    }
    function displayField(haystack, label) {

      const type = typeForm.value;
      const subject = subjectForm.value;
      const isProspect = isClient.value === "" || isClient.value === false;

      if (label === "Résilier mon contrat") {
        const contractMap = {
          "Gaz en citerne": ["Particulier"],
        };

        if (contractMap[subject]) {
          return subject !== '' && contractMap[subject].includes(type) && !isProspect
        } else {
          return false;
        }
      }

      if(label === "Passer une commande de gaz"){
        const gazMap = {
          "Gaz en citerne": [
            "Professionnel",
            "Collectivité",
            "Particulier",
          ],
        }

        if (gazMap[subject]) {
          return subject !== '' && gazMap[subject].includes(type) && !isProspect && (isClient.value != "" && isClient.value !== undefined && isClient.value !== null)
        } else {
          return false;
        }
      }


      if(label == "Demande de devis" ){
        // cas 1 : "Particulier"   "Gaz en citerne"   false
        // cas 2 : "Professionnel" "Gaz en citerne"   false
        // cas 3 : "Professionnel" "Bouteille de gaz" false
        // cas 4 : "Collectivité"  "Gaz en citerne"   false
        // cas 5 : "Collectivité"  "Bouteille de gaz" false
        // cas 6 : "Prescripteur"  "Gaz en citerne"   false

        const map = {
          "Bouteilles de gaz" : {
          "Professionnel" : "https://www.antargaz.fr/devenez-client-pro-bouteilles",
          "Collectivité" : "https://www.antargaz.fr/devenez-client-pro-bouteilles"
          },
          "Gaz en citerne" : {
            "Particulier" : "https://www.antargaz.fr/citerne-de-gaz/generique-particuliers",
            "Professionnel" : "https://www.antargaz.fr/citerne-de-gaz/generique-professionnels" ,
            "Collectivité" : "https://www.antargaz.fr/citerne-de-gaz/generique-professionnels",
            "Prescripteur" : "https://www.antargaz.fr/citerne-de-gaz/generique-particuliers"
          },
          "Propane en réseau": {
            "Professionnel" : "",
            "Collectivité" : "",
            "Particulier" : ""
          },
        }
        if (map[subject]) {
          const req = selects.requests.find(r => r.label === label);
          if (map[subject].hasOwnProperty(type) && map[subject][type] !== "" ) {
            req.url = map[subject][type]; // Récupérer l'URL associée au type
            req.isLink = true;
          } else {
            req.url = ""
            req.isLink = false; // URL par défaut si le type n'est pas trouvé
          }
          return subject !== '' && map[subject].hasOwnProperty(type) && isProspect
        } else {
          return false;
        }
      }
      if (!haystack) {
        return true;
      }
      return haystack.includes(subjectForm.value);
    }

    function updateSelectsSubject() {
      selects.subjects = selects.subjects.map((subject) => ({
        ...subject,
        display: displayFieldSubject(subject.haystack),
      }));
    }
    function displayFieldSubject(haystack) {
      if (!haystack) {
        return true;
      }
      return haystack.includes(typeForm.value);
    }
    function checkPopin() {
      if (
        subjectForm === "Gaz en citerne" &&
        typeForm != "Prescripteur"
      ) {
        // togglePopin(true) fix/AZS-361 : disable popin till further notice
        return;
      }
    }

    return {
      context,
      checkPopin,
      updateSelectsSubject,
      isDemandeDevis,
      updateSelects,
      isPosted,
      captchaError,
      displayPopin,
      recaptcha,
      newForm,
      selects,
      formEl,
      phoneNumbers,
      isFormActive,
      showForm,
      showConfirmation,
      showPhones,
      nomcommercial,
      showCategory,
      isParticulier,
      showIsClient,
      isClient,
      formatPhoneNumber,
      updateDatalayer,
      togglePopin,
      onCaptchaExpired,
      onCaptchaVerified,
      checkRecaptcha,
      submitForm,
      sendForm,
      initFAQ,
      setFocusState,
      setBlurState,
      getSelectEmailValue,
      setContext,
      resetClientCheckbox,
      contactFields,
      errors,
      navigateToContactPage,
      values,
      country,
      email,
      number,
      phone,
      firstname,
      lastname,
      clientnumber,
      typeForm,
      request,
      subjectForm,
      visibleSubjects,
      visibleRequests,
      requestChanged,
    };
  },
};
</script>

<style lang="sass" src="./contact.sass"></style>
